export const FIRST_REQUEST = 'FIRST_REQUEST';
export const LOAD_MORE = 'LOAD_MORE';